const invertedMessages = {
  'Close Banner': 'External.AriaLabel.CloseBanner',
};

export default invertedMessages;
